import { Tooltip } from 'antd';
import React, { ReactElement } from 'react';
import styles from './DataStoreStatus.module.less';
import DeploymentsItem from '../../../types/DeploymentsItem';
import CcxComponentProps from '../../../core/CcxComponent';
import DotLabelStatus from '../../ccx/common/DotLabelStatus';
import SmallContainer from '../../ccx/common/SmallContainer';

interface Props extends CcxComponentProps {
    dataStore: DeploymentsItem;
    updating?: boolean;
}

function DataStoreStatus({
    dataStore,
    testId = 'DataStoreStatus',
    updating = false,
}: Props): ReactElement {
    let StatusComponent = null;

    if (dataStore?.isStatusOk()) {
        StatusComponent = (
            <DotLabelStatus
                type="ok"
                label={dataStore?.getDataStoreStatus()}
                glow={updating}
                testId={`${testId}StatusComponent`}
            />
        );
    } else if (dataStore?.isStatusError()) {
        StatusComponent = (
            <DotLabelStatus
                type="error"
                label={dataStore?.getDataStoreStatus()}
                glow={updating}
                testId={`${testId}StatusComponent`}
            />
        );
    } else if (dataStore?.isStatusWarning()) {
        StatusComponent = (
            <DotLabelStatus
                type="warning"
                label={dataStore?.getDataStoreStatus()}
                glow={updating}
                testId={`${testId}StatusComponent`}
            />
        );
    } else if (dataStore?.isDeleting()) {
        StatusComponent = (
            <DotLabelStatus
                type="normal"
                label={dataStore?.getDataStoreStatus()}
                glow={updating}
                testId={`${testId}StatusComponent`}
            />
        );
    } else if (dataStore?.isDeploying()) {
        StatusComponent = (
            <DotLabelStatus
                type="info"
                label={`${dataStore?.getDataStoreStatus()}... ${dataStore?.getDeploymentProgressText()}`}
                glow={updating}
                testId={`${testId}StatusComponent`}
            />
        );
    } else {
        StatusComponent = (
            <DotLabelStatus
                type="normal"
                label={dataStore?.getDataStoreStatus()}
                glow={updating}
                testId={`${testId}StatusComponent`}
            />
        );
    }

    const tooltipTitle = dataStore?.isStatusError()
        ? `${dataStore?.getNotes()}`
        : dataStore?.isStatusWarning()
        ? null
        : `${dataStore?.getDataStoreStatusText()}`;

    const top = (
        <Tooltip placement="bottom" title={tooltipTitle}>
            {StatusComponent}{' '}
        </Tooltip>
    );

    return <SmallContainer testId={testId} topChildren={top} />;
}

export default DataStoreStatus;
